import RepetitionInterval from '@/domain/termine/components/RepetitionInterval';
import { DatePickerFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/DatePickerFormField';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { TerminWiederholung } from '@/domain/termine/shared/types';
import { useTranslation } from 'react-i18next';
import { RepetitionIntervalDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/RepetitionIntervalDrawer';
import { Field, FieldLabel } from '@e2n/ui';
import { IndividualRepetitionDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/IndividualRepetitionDrawer';
import { IndividuelleWiederholungCard } from '@/domain/termine/features/CreateTermin/Sheet/components/IndividuelleWiederholungCard';
import { useState } from 'react';

export function RepetitionIntervalFormField() {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col gap-2 w-full">
      <form.Field name="wiederholung">
        {(field) => (
          <Field className="flex flex-col w-full gap-1">
            <FieldLabel>{t('domain.termine.repeat')}</FieldLabel>
            <div className="block md:hidden">
              <RepetitionIntervalDrawer
                value={field.state.value ?? TerminWiederholung.OHNE}
                onChange={(value) => {
                  field.handleChange(value);
                  if (value === TerminWiederholung.INDIVIDUELL) {
                    setOpen(true);
                  }
                }}
              />
            </div>
            <div className="hidden md:block">
              <RepetitionInterval
                value={field.state.value ?? TerminWiederholung.OHNE}
                onChange={field.handleChange}
              />
            </div>
          </Field>
        )}
      </form.Field>
      <form.Subscribe selector={(state) => state.values.wiederholung}>
        {(selectedRepetition) => (
          <>
            {selectedRepetition !== TerminWiederholung.OHNE &&
              selectedRepetition !== TerminWiederholung.INDIVIDUELL && (
                <DatePickerFormField name="wiederholungBis" />
              )}

            {selectedRepetition === TerminWiederholung.INDIVIDUELL && (
              <div className="flex w-full min-w-0 flex-col gap-1">
                <div className="hidden w-full md:block">
                  <IndividuelleWiederholungCard />
                </div>
                <div className="block w-full md:hidden">
                  <IndividualRepetitionDrawer
                    open={open}
                    onOpenChange={setOpen}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </form.Subscribe>
    </div>
  );
}
